import styled from 'styled-components';

const Text = styled.span`
  color: ${({ color }) => color || '#000'};
  font-size: ${({ fontSize }) => fontSize || '13px'};
  ${({ fontFamily }) => fontFamily && `font-family: ${fontFamily};`};
`;

export default Text;
